// extracted by mini-css-extract-plugin
module.exports = {"pageHeadingTitle":"adminWork-screen_pageHeadingTitle__2Q2ln"};